import { useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

type StatusGetSolicitudCATAFuegoByID = {
    status: number | null;
    statusText: string | null;
};

const getBackendMessage = (error: any) => {
    const responseData = error?.response?.data;
    return (
        (typeof responseData === 'string' ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        error?.response?.statusText ||
        error?.message ||
        'Error'
    );
};

const useGetSolicitudCATAFuegoByID = () => {
    const [loadingGetSolicitudCATAFuegoByID, setLoadingGetSolicitudCATAFuegoByID] = useState(false);
    const [successGetSolicitudCATAFuegoByID, setSuccessGetSolicitudCATAFuegoByID] = useState(false);
    const [errorGetSolicitudCATAFuegoByID, setErrorGetSolicitudCATAFuegoByID] = useState<any>(null);
    const [dataGetSolicitudCATAFuegoByID, setDataGetSolicitudCATAFuegoByID] = useState<any>(null);
    const [statusGetSolicitudCATAFuegoByID, setStatusGetSolicitudCATAFuegoByID] = useState<StatusGetSolicitudCATAFuegoByID>({
        status: null,
        statusText: null,
    });

    const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
    const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
    const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

    const getSolicitudCATAFuegoByID = async (
        userId: string,
        prestacionId: string,
        id: string,
        callback?: (data: any) => void
    ) => {
        setLoadingGetSolicitudCATAFuegoByID(true);
        setSuccessGetSolicitudCATAFuegoByID(false);
        setErrorGetSolicitudCATAFuegoByID(null);

        try {
            const response = await apiRecord.getSolicitudCataFmIncendioByID(userId, prestacionId, id);
            setStatusGetSolicitudCATAFuegoByID({
                status: response.status,
                statusText: response.statusText ?? response.response ?? null,
            });
            setSuccessGetSolicitudCATAFuegoByID(true);
            setDataGetSolicitudCATAFuegoByID(response.data);
            callback?.(response.data);
            return response.data;
        } catch (error: any) {
            setStatusGetSolicitudCATAFuegoByID({
                status: error?.response?.status || 500,
                statusText: getBackendMessage(error),
            });
            setErrorGetSolicitudCATAFuegoByID(error);
            throw error;
        } finally {
            setLoadingGetSolicitudCATAFuegoByID(false);
        }
    };

    return {
        getSolicitudCATAFuegoByID,
        loadingGetSolicitudCATAFuegoByID,
        successGetSolicitudCATAFuegoByID,
        errorGetSolicitudCATAFuegoByID,
        dataGetSolicitudCATAFuegoByID,
        statusGetSolicitudCATAFuegoByID,
    };
};

export default useGetSolicitudCATAFuegoByID;